import React from "react";

import { customClasses } from "../../../Styles/customClasses";

import leftShape from "../../../Assets/left-square-shape.png";
//form
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { FormError, FormInput, FormRadio } from "../../../Components/Basic";

// schema
const schema = yup.object().shape({
  marriage_date: yup.string().required("This is required").nullable(),
  marriage_cert_if_get: yup.string().required("This is required").nullable(),
  marriage_place: yup
    .string()
    .when("marriage_cert_if_get", (marriage_cert_if_get) => {
      if (marriage_cert_if_get === "No")
        return yup.string().required("This is required").nullable();
    }),
  marriage_cert_if_english: yup
    .string()
    .required("This is required")
    .nullable(),
});

function UserQuest1({ onSubmit, store }) {
  const {
    handleSubmit,
    register,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: store,
    resolver: yupResolver(schema),
  });
  return (
    <form id="divorce-form" onSubmit={handleSubmit(onSubmit)}>
      <section className={customClasses.stepsWrapper}>
        <p className="text-2xl font-bold ">
          Answer these quick questions to find out the cost.
        </p>
        <div className="bg-nativeBlue-200 rounded-lg ">
          <p className="text-center text-white font-bold py-3 mt-10 mb-4	text-3xl ">
            Part 1 of 2
          </p>
        </div>

        <p className={customClasses.questionText}>When did you get married?</p>
        <FormInput
          placeholder="type or select the date"
          id="marriage_date"
          type="date"
          name="marriage_date"
          error={errors?.marriage_date?.message}
          register={register}
        />

        <p className={customClasses.questionText}>
          Do you have a copy of the marriage certificate?
        </p>
        <FormRadio
          register={register}
          name={"marriage_cert_if_get"}
          setValue={setValue}
          value="Yes"
        />
        <FormRadio
          register={register}
          name={"marriage_cert_if_get"}
          setValue={setValue}
          value="No"
        />
        <FormError error={errors.marriage_cert_if_get?.message} />
        {watch("marriage_cert_if_get") === "No" && (
          <>
            <p className={customClasses.questionText}>
              Where did you get married?
            </p>
            <FormRadio
              register={register}
              name={"marriage_place"}
              setValue={setValue}
              value="Australia"
            />
            <FormRadio
              register={register}
              name={"marriage_place"}
              setValue={setValue}
              value="Overseas"
            />
            <FormError error={errors.marriage_place?.message} />
          </>
        )}

        <p className={customClasses.questionText}>
          Is your marriage certificate in English?
        </p>
        <FormRadio
          register={register}
          name={"marriage_cert_if_english"}
          setValue={setValue}
          value="Yes"
        />
        <FormRadio
          register={register}
          name={"marriage_cert_if_english"}
          setValue={setValue}
          value="No"
        />
        <FormError error={errors.marriage_cert_if_english?.message} />
      </section>
      <section>
        <img
          className="invisible md:visible w-1/6 absolute top-40 left-0 mr-10 "
          src={leftShape}
          alt="shape"
        />
      </section>
    </form>
  );
}

export default UserQuest1;
